import type { PromptGroup, TopicOption } from '@/types/database-schema';

type TopicProject = {
  prompt_groups?: PromptGroup[];
  topic_options?: TopicOption[];
};

export function projectTopicOptions(project?: TopicProject | null): TopicOption[] {
  return (
    project?.topic_options ??
    (project?.prompt_groups || []).map(group => ({
      ...group,
      origin: 'local',
      editable: true,
    }))
  );
}

export function topicOrigin(group?: PromptGroup | null): 'shared' | undefined {
  return group && 'origin' in group && group.origin === 'shared' ? 'shared' : undefined;
}

export function isEditableTopic(group?: PromptGroup | null): boolean {
  return Boolean(group && !topicOrigin(group) && (!('editable' in group) || group.editable));
}

export function topicFilterOptions(groups: PromptGroup[], allLabel = 'All topics') {
  return [
    { value: '', label: allLabel },
    ...groups.map(group => ({
      value: group.id,
      label: group.name,
      group: topicOrigin(group) ? 'Attune topics' : 'Your topics',
    })),
  ];
}

export function promptsInScope<T extends { prompt_id: string }>(
  prompts: T[],
  selectedTopic?: PromptGroup,
  customPromptIds: string[] = [],
  subtopicId = ''
): T[] {
  const members = selectedTopic
    ? new Set(
        subtopicId
          ? selectedTopic.subtopics?.find(child => child.id === subtopicId)?.prompt_ids || []
          : selectedTopic.prompt_ids
      )
    : subtopicId
      ? new Set<string>()
      : null;
  const custom = customPromptIds.length ? new Set(customPromptIds) : null;
  return members || custom
    ? prompts.filter(
        prompt =>
          (!members || members.has(prompt.prompt_id)) && (!custom || custom.has(prompt.prompt_id))
      )
    : prompts;
}
